export function toMap<T extends { id: string }>(list: T[] | undefined): Map<string, T> {
  return new Map((list ?? []).map((entry) => [entry.id, entry]));
}
